import process from "process";

const isProd = process.env.NODE_ENV === 'production'
const isTest = process.env.NODE_ENV === 'test'
const isDev = !(isProd || isTest)


const dev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development'


const SERVER_URL = dev ? 'http://127.0.0.1:8000' : '' // set this if your API server is different from the frontend server

const SITE_NAME = 'EsteiDentistry'
const COPYRIGHT = 'EsteiDentistry'

const HIGHLIGHT_LANGUAGES = [
    'javascript',
    'json',
    'python',
    'scss',
    'yaml',
]

export {
    SERVER_URL,
    SITE_NAME,
    COPYRIGHT,
    HIGHLIGHT_LANGUAGES,
}